import "./style.css";
import { useState, useEffect } from "react";
import Loader from "./components/loader";

function App() {
  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [locs, setLocs] = useState([]);
  const [visitor, setVisitor] = useState([]);
  const [market, setMarket] = useState("");
  const [zipError, setZipError] = useState(false);
  const [locationError, setLocationError] = useState(false);
  const [opts, setOpts] = useState([]);
  const [pageContent, setPageContent] = useState(null);
  const [pageContentLoading, setPageContentLoading] = useState(true);
  const [industryError, setIndustryError] = useState("");

  useEffect(() => {
    fetch("/wp-json/ats/find-your-rep-content")
      .then((res) => res.json())
      .then((data) => setPageContent(data))
      .catch(() => setPageContent(null))
      .finally(() => setPageContentLoading(false));
  }, []);
  const golfOpts = [
    {
      label: "Assistant Superintendent",
      name: "assistant-superintendent",
    },
    {
      label: "Superintendent",
      name: "superintendent",
    },
    {
      label: "Golf Course Owner",
      name: "golf-course-owner",
    },
    {
      label: "Spray Technician",
      name: "spray-technician",
    },
    {
      label: "Other",
      name: "other",
    },
  ];

  const lawnOpts = [
    {
      label: "Owner",
      name: "owner",
    },
    {
      label: "Operator",
      name: "operator",
    },
    {
      label: "Manager",
      name: "manager",
    },
    {
      label: "Branch Manager",
      name: "branch-manager",
    },
    {
      label: "Other",
      name: "other",
    },
  ];

  const sportOpts = [
    {
      label: "Contractor",
      name: "contractor",
    },
    {
      label: "Architect",
      name: "architect",
    },
    {
      label: "Director of Facilities",
      name: "director-of-facilities",
    },
    {
      label: "Director of Maintenance",
      name: "director-of-maintenance",
    },
    {
      label: "Manager",
      name: "manager",
    },
    {
      label: "Athletic Director",
      name: "athletic-director",
    },
    {
      label: "Head Groundskeeper",
      name: "head-groundkeepers",
    },
    {
      label: "Field Manager",
      name: "field-manager",
    },
    {
      label: "Assistante Groundkeeper",
      name: "assistantance-groundkeeper",
    },
    {
      label: "Other",
      name: "other",
    },
  ];

  const handleFilterChange = (event) => {
    setMarket(event.target.value);
    setIndustryError("");
    if (event.target.value === "golf-course") {
      setOpts(golfOpts);
    }
    if (event.target.value === "lawn-and-landscape") {
      setOpts(lawnOpts);
    }
    if (event.target.value === "sports-field") {
      setOpts(sportOpts);
    }
  };

  const handleVisitor = (event) => {
    const value = event.target.value;

    if (event.target.checked) {
      // Add the value to the array
      setVisitor((prev) => [...prev, value]);
    } else {
      // Remove the value from the array
      setVisitor((prev) => prev.filter((item) => item !== value));
    }
  };

  const formatMarket = (str) => {
    return str
      .split("-")
      .map(
        (segment) =>
          segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase()
      )
      .join(" ");
  };
  const handleSubmission = (e) => {
    e.preventDefault();
    const zip = document.getElementById("zip");
    let hasError = false;
    if (zip.value.trim() === "") {
      setZipError(true);
      hasError = true;
    }
    if (market === "") {
      setIndustryError("Please click the option that best describes you.");
      hasError = true;
    }
    if (hasError) return;
    setZipError(false);
    setLocationError(false);
    setIndustryError("");
    setLocs([]);
    setNotFound(false);
    setLoading(true);
    geoLocate(zip.value.trim());
  };

  const geoLocate = async (zip) => {
    setNotFound(false);
    setLocationError(false);
    try {
      const call = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places-permanent/${zip}.json?access_token=pk.eyJ1IjoiZnJvbnRwb3IiLCJhIjoiY2xidjhnbGV2MXlmZTNvbzkxNDgzamczcCJ9._3eukN1cI_LhCDOp40qRkQ&country=US`
      );
      const response = await call.json();

      if (!response.features || response.features.length === 0) {
        setLocationError(true);
        setLoading(false);
        return;
      }

      const coords = response.features[0].geometry.coordinates;
      const [lat, long] = [coords[1], coords[0]];
      getCloserLocs(lat, long);
    } catch (err) {
      setLocationError(true);
      setLoading(false);
    }
  };

  const formatMarkets = (input) => {
    // Replace all hyphens with spaces
    let formatted = input.replace(/-/g, " ");

    // Capitalize each word
    formatted = formatted
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    // Specific case for "Lawn And Lawnscape"
    if (formatted === "Lawn And Landscape") {
      formatted = formatted.replace("And", "&");
    }

    return formatted;
  };

  const getCloserLocs = async (lat, long) => {
    setLoading(false);
    setLocationError(false);
    try {
      const call = await fetch(
        `/wp-json/reps/closer?lat=${lat}&lng=${long}&filter=${market}`
      );
      const response = await call.json();

      const totalReps = Array.isArray(response)
        ? response.reduce(
            (sum, loc) => sum + (Array.isArray(loc.reps) ? loc.reps.length : 0),
            0
          )
        : 0;

      if (!response || response.length === 0 || totalReps === 0) {
        setNotFound(true);
      } else {
        const sortedResponse = response.map((loc) => {
          // Ensure loc.reps exists and is an array
          if (loc.reps && Array.isArray(loc.reps)) {
            loc.reps.sort((a, b) => {
              if (
                a.position === "Branch Manager" &&
                b.position !== "Branch Manager"
              ) {
                return -1;
              } else if (
                b.position === "Branch Manager" &&
                a.position !== "Branch Manager"
              ) {
                return 1;
              }
              return 0;
            });
          }
          return loc;
        });

        setLocs(sortedResponse);
      }
    } catch (err) {
      setNotFound(true);
    }
  };

  useEffect(() => {
    if (locs.length > 0) {
      const resultsEl = document.getElementById("reps-results");
      resultsEl?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [locs.length]);

  return (
    <div className="container px-4 pt-10 pb-4 mx-auto lg:px-0">
      <div className="items-center lg:grid lg:grid-cols-12 lg:gap-6">
        <div className="mb-16 lg:col-span-12 lg:grid lg:grid-cols-12 lg:gap-6">
          <div className="lg:col-span-5 lg:col-start-2">
            {pageContentLoading ? (
              <div className="animate-pulse" aria-hidden="true">
                <div className="mb-3 w-3/4 h-10 bg-gray-200 rounded md:h-14" />
                <div className="mb-2 w-full h-4 bg-gray-200 rounded" />
                <div className="mb-2 w-5/6 h-4 bg-gray-200 rounded" />
                <div className="mb-2 w-4/6 h-4 bg-gray-200 rounded" />
              </div>
            ) : pageContent ? (
              <div
                className="page-content"
                dangerouslySetInnerHTML={{ __html: pageContent.content }}
              />
            ) : (
              <>
                <h1 className="mb-2 text-3xl font-bold md:text-5xl">
                  Find Your ATS Representative
                </h1>
                <p>
                  <strong>
                    Can't remember your sales rep's name? Don't have a sales rep?
                  </strong>
                  <br />
                  Please fill in the form below to see a list of the closest sales
                  representatives and warehouses
                </p>
              </>
            )}
            <form id="reps-zip w-full">
                <div className="block w-full zip last:relative">
                  <label
                    htmlFor="zip"
                    className="block mt-6 mb-2 w-full font-bold">
                    What’s your ZIP Code?
                  </label>
                  <input
                    className={`w-full lg:max-w-[400px] py-3 pl-4 pr-8 border xl:max-w-[500px] bg-gray-100 focus:outline-none duration-200 transition-all text-gray-600 ${
                      zipError || locationError ? "border-red-500 focus:border-red-500" : "border-gray-100 focus:border-gray-300"
                    }`}
                    type="text"
                    autoComplete="off"
                    id="zip"
                    aria-label="zip"
                    placeholder="Enter your zip code"
                    aria-invalid={zipError || locationError}
                    aria-describedby={
                      zipError ? "zip-error" : locationError ? "location-error" : undefined
                    }
                    onChange={() => {
                      if (zipError) setZipError(false);
                      if (locationError) setLocationError(false);
                    }}
                  />
                  {zipError && (
                    <p id="zip-error" className="mt-2 text-sm font-medium text-red-600" role="alert">
                      Please enter your zip code to search for representatives.
                    </p>
                  )}
                  {locationError && (
                    <p id="location-error" className="mt-2 text-sm font-medium text-red-600" role="alert">
                      We couldn&apos;t find that zip code. Please try another.
                    </p>
                  )}
                  {notFound && (
                    <div className="p-5 mt-4 text-red-600 border border-red-600">
                      <h3 className="mb-1 text-lg font-semibold text-red-600">
                        We couldn't find a sales representative in your area at this time.
                      </h3>
                      Please check back in the future to see if our service area has
                      expanded.
                    </div>
                  )}
                  {loading && <Loader />}
                </div>
                <div className="mt-6 filters">
                  <strong className="block mb-4 w-full">
                    Refine Results by Industry
                  </strong>
                  <div className="flex flex-col gap-2 xl:flex-row xl:gap-0">
                    <label>
                      <input
                        type="radio"
                        id="gc"
                        name="filter"
                        value="golf-course"
                        className="inline-block"
                        checked={market === "golf-course"}
                        onChange={handleFilterChange}
                      />{" "}
                      <span className="inline-block mr-5">Golf Course</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        id="ll"
                        name="filter"
                        value="lawn-and-landscape"
                        className=""
                        checked={market === "lawn-and-landscape"}
                        onChange={handleFilterChange}
                      />{" "}
                      <span className="inline-block mr-5">
                        Lawn & Landscape
                      </span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        id="sf"
                        value="sports-field"
                        name="filter"
                        className=""
                        checked={market === "sports-field"}
                        onChange={handleFilterChange}
                      />{" "}
                      <span className="inline-block mr-5">Sports Field</span>
                    </label>
                  </div>
                  {industryError && (
                    <p className="mt-2 text-sm font-medium text-red-600" role="alert">
                      {industryError}
                    </p>
                  )}
                </div>
                <div className="mt-6 filters">
                  {opts.length > 0 && (
                    <strong className="block mb-2 w-full">
                      Select any that apply to you
                    </strong>
                  )}
                  <div className="flex flex-col md:flex-row md:flex-wrap xl:grid xl:grid-cols-2">
                    {opts.length > 0 &&
                      opts.map((opt, index) => (
                        <div
                          className="flex gap-2 items-center mb-2 w-full"
                          key={index}>
                          <input
                            type="checkbox"
                            id={opt.name}
                            value={opt.name}
                            name="reqdata"
                            className="inline-block"
                            checked={visitor.includes(opt.name)}
                            onChange={(e) => handleVisitor(e)}
                          />{" "}
                          <span className="inline-block mr-5">{opt.label}</span>
                        </div>
                      ))}
                  </div>
                </div>

                <button
                  type="submit"
                  onClick={(e) => handleSubmission(e)}
                  disabled={opts < 0}
                  className="w-full button button--primary lg:w-auto inline-block text-white py-3 px-14 text-sm font-semibold rounded transition-all duration-200 capitalize eff-a__button my-1 bg-[#215732]">
                  {" "}
                  {loading ? "Locating" : "Search for Reps"}
                </button>
              </form>
          </div>
          {pageContentLoading ? (
            <div className="hidden justify-end items-center lg:flex lg:col-span-5">
              <div
                className="bg-gray-200 rounded-lg animate-pulse w-[461px] h-[656px]"
                aria-hidden="true"
              />
            </div>
          ) : (
            pageContent &&
            pageContent.image && (
              <div className="hidden justify-end items-center lg:flex lg:col-span-5">
                <div>
                  <img
                    src={pageContent.image}
                    width="461"
                    className="rounded-lg"
                    alt={pageContent.alt || ""}
                  />
                </div>
              </div>
            )
          )}
        </div>

        {locs.length > 0 && (
          <div id="reps-results" className="lg:col-start-2 lg:col-span-10 scroll-mt-6">
            {locs.map((loc, index) => {
              return (
                loc.reps.length > 0 && (
                  <div key={index} className="mb-10">
                    <span className="text-xl font-bold">
                      ATS Representatives in{" "}
                      {loc.not_physical ? (
                        <span>{loc.name}, {loc.short_state}</span>
                      ) : (
                        <a
                          href={loc.url + "?vs=" + visitor + "&mkt=" + market}
                          className="underline underline-offset-4">
                          {loc.name}, {loc.short_state}
                        </a>
                      )}
                    </span>
                    {market !== "" && (
                      <>
                        <br />
                        <span className="text-sm font-bold">
                          By {formatMarket(market)} Industry
                        </span>
                      </>
                    )}
                    <br />
                    <span className="text-xs text-gray-600">
                      {loc.distance} Miles
                    </span>
                    <div className="grid gap-8 mt-8 lg:grid-cols-2">
                      {loc.reps.map((rep, index) => {
                        return (
                          <div
                            className="flex flex-col gap-4 justify-center items-center p-5 text-center rounded border border-gray-300 md:grid-cols-9 md:grid md:text-left lg:text-center lg:flex lg:flex-col xl:grid xl:grid-cols-9 xl:text-left rep"
                            key={index}>
                            {rep.portrait !== "" ? (
                              <div
                                className="overflow-hidden col-span-2 w-28 h-28 rounded-full border border-gray-200 portrait xl:h-24 xl:w-24"
                                dangerouslySetInnerHTML={{
                                  __html: rep.portrait,
                                }}
                              />
                            ) : (
                              <div className="col-span-2 w-28 h-28 portrait">
                                <svg
                                  width="100"
                                  height="100"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M17.982 18.7249C17.2833 17.7998 16.3793 17.0496 15.3412 16.5333C14.3031 16.0171 13.1594 15.7489 12 15.7499C10.8407 15.7489 9.6969 16.0171 8.65883 16.5333C7.62077 17.0496 6.71675 17.7998 6.01801 18.7249M17.982 18.7249C19.3455 17.5121 20.3071 15.9135 20.7412 14.141C21.1753 12.3686 21.0603 10.506 20.4115 8.80043C19.7627 7.09482 18.6107 5.62673 17.1084 4.59085C15.6061 3.55497 13.8244 3.00024 11.9995 3.00024C10.1747 3.00024 8.39295 3.55497 6.89062 4.59085C5.38829 5.62673 4.23634 7.09482 3.58755 8.80043C2.93875 10.506 2.82376 12.3686 3.25783 14.141C3.6919 15.9135 4.65451 17.5121 6.01801 18.7249M17.982 18.7249C16.336 20.1931 14.2056 21.0031 12 20.9999C9.79404 21.0033 7.66425 20.1934 6.01801 18.7249M15 9.74995C15 10.5456 14.6839 11.3087 14.1213 11.8713C13.5587 12.4339 12.7957 12.7499 12 12.7499C11.2044 12.7499 10.4413 12.4339 9.87869 11.8713C9.31608 11.3087 9.00001 10.5456 9.00001 9.74995C9.00001 8.9543 9.31608 8.19124 9.87869 7.62863C10.4413 7.06602 11.2044 6.74995 12 6.74995C12.7957 6.74995 13.5587 7.06602 14.1213 7.62863C14.6839 8.19124 15 8.9543 15 9.74995Z"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                            )}

                            <div className="col-span-4 data">
                              <a
                                className="text-xl font-bold"
                                href={rep.profile + "?search=true"}>
                                {rep.name}
                              </a>
                              <p className="xl:text-[15px]">{rep.position}</p>
                              <div>
                                <svg
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="inline-block mr-1">
                                  <g clipPath="url(#clip0_1921_2560)">
                                    <path
                                      d="M15.3835 13.2778C15.4693 13.2207 15.568 13.1859 15.6706 13.1766C15.7732 13.1672 15.8766 13.1836 15.9713 13.2243L19.6238 14.8608C19.7469 14.9134 19.8496 15.0045 19.9167 15.1204C19.9837 15.2363 20.0114 15.3707 19.9956 15.5037C19.8752 16.4029 19.4324 17.2278 18.7495 17.825C18.0665 18.4222 17.1899 18.751 16.2826 18.7503C13.4891 18.7503 10.8099 17.6406 8.83459 15.6653C6.85925 13.6899 5.74951 11.0108 5.74951 8.21722C5.74882 7.30998 6.07765 6.43337 6.67485 5.75041C7.27205 5.06744 8.09697 4.62462 8.99619 4.5043C9.12912 4.4885 9.26359 4.51619 9.37947 4.5832C9.49535 4.65022 9.58641 4.75296 9.63903 4.87605L11.2755 8.53167C11.3157 8.62556 11.3321 8.72793 11.3232 8.82968C11.3143 8.93143 11.2803 9.0294 11.2244 9.11486L9.56932 11.0829C9.51061 11.1714 9.47589 11.2737 9.46856 11.3798C9.46123 11.4858 9.48154 11.5919 9.5275 11.6877C10.168 12.999 11.5234 14.3381 12.8385 14.9724C12.9348 15.0181 13.0414 15.038 13.1477 15.03C13.2541 15.0219 13.3565 14.9863 13.4449 14.9267L15.3835 13.2778Z"
                                      stroke="black"
                                      strokeWidth="1.65226"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1921_2560">
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                        transform="translate(0.5)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                                <p className="inline-block">{rep.phone}</p>
                              </div>
                              <div>
                                <svg
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                  className="inline-block mr-1"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M5.29004 10.4999H3.29004C3.02482 10.4999 2.77047 10.6053 2.58293 10.7928C2.3954 10.9803 2.29004 11.2347 2.29004 11.4999C2.29004 11.7651 2.3954 12.0195 2.58293 12.207C2.77047 12.3945 3.02482 12.4999 3.29004 12.4999H5.29004C5.55526 12.4999 5.80961 12.3945 5.99715 12.207C6.18468 12.0195 6.29004 11.7651 6.29004 11.4999C6.29004 11.2347 6.18468 10.9803 5.99715 10.7928C5.80961 10.6053 5.55526 10.4999 5.29004 10.4999ZM22.07 7.6599V7.5999C21.7835 7.24969 21.4215 6.96882 21.0111 6.77833C20.6007 6.58784 20.1525 6.49265 19.7 6.4999H11.77C11.0352 6.4933 10.3236 6.75661 9.77004 7.2399C9.25304 7.69543 8.91313 8.3186 8.81004 8.9999L7.93004 13.9999C7.85437 14.4317 7.87424 14.8748 7.98827 15.2981C8.1023 15.7214 8.30771 16.1145 8.59004 16.4499C8.8709 16.7841 9.22132 17.053 9.61685 17.2378C10.0124 17.4227 10.4435 17.5189 10.88 17.5199H18.82C19.5333 17.5307 20.227 17.287 20.7768 16.8325C21.3266 16.378 21.6965 15.7424 21.82 15.0399L22.7 10.0399C22.7693 9.6212 22.749 9.19256 22.6404 8.78229C22.5318 8.37203 22.3374 7.98947 22.07 7.6599ZM19.33 8.4999L15.93 11.2599C15.729 11.4219 15.4731 11.4999 15.2159 11.4775C14.9587 11.4552 14.7201 11.3342 14.55 11.1399L12.22 8.4999H19.33ZM19.81 14.6699C19.7696 14.9047 19.6466 15.1173 19.4632 15.2695C19.2799 15.4217 19.0483 15.5034 18.81 15.4999H10.88C10.7348 15.4987 10.5916 15.4658 10.4604 15.4037C10.3291 15.3415 10.213 15.2515 10.12 15.1399C10.0269 15.0289 9.95893 14.899 9.92094 14.7591C9.88296 14.6192 9.87582 14.4728 9.90004 14.3299L10.7 9.7999L13.05 12.4599C13.5615 13.0413 14.278 13.4023 15.0496 13.4676C15.8212 13.5328 16.5882 13.2971 17.19 12.8099L20.63 9.9999L19.81 14.6699ZM6.29004 6.4999H3.29004C3.02482 6.4999 2.77047 6.60525 2.58293 6.79279C2.3954 6.98033 2.29004 7.23468 2.29004 7.4999C2.29004 7.76511 2.3954 8.01947 2.58293 8.207C2.77047 8.39454 3.02482 8.4999 3.29004 8.4999H6.29004C6.55526 8.4999 6.80961 8.39454 6.99715 8.207C7.18468 8.01947 7.29004 7.76511 7.29004 7.4999C7.29004 7.23468 7.18468 6.98033 6.99715 6.79279C6.80961 6.60525 6.55526 6.4999 6.29004 6.4999Z"
                                    fill="#232323"
                                  />
                                </svg>
                                <a
                                  href={
                                    rep.profile +
                                    "?search=true"
                                  }>
                                  Send email
                                </a>
                              </div>
                            </div>
                            <div className="col-span-3 text-center action">
                              <a
                                href={rep.profile + "?search=true"}
                                className="py-2 mt-0 border button button--outline border-dark_grey text-dark_grey hover:text-primary hover:border-primary xl:px-[15px]">
                                <svg
                                  className="inline-block mr-1"
                                  width="24"
                                  height="25"
                                  viewBox="0 0 24 25"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <g clipPath="url(#clip0_1921_2682)">
                                    <path
                                      d="M17.084 16.312C18.0244 15.3184 18.653 14.071 18.8922 12.724C19.1314 11.377 18.9706 9.9894 18.4297 8.73278C17.8888 7.47616 16.9916 6.40558 15.8489 5.65336C14.7062 4.90113 13.3681 4.50025 12 4.50025C10.6319 4.50025 9.29384 4.90113 8.15112 5.65336C7.00841 6.40558 6.11117 7.47616 5.5703 8.73278C5.02943 9.9894 4.86863 11.377 5.1078 12.724C5.34696 14.071 5.9756 15.3184 6.916 16.312C7.45567 15.4508 8.20536 14.741 9.09467 14.2491C9.98398 13.7572 10.9837 13.4994 12 13.5C13.0163 13.4994 14.016 13.7572 14.9053 14.2491C15.7946 14.741 16.5443 15.4508 17.084 16.312ZM12 24.228L5.636 17.864C4.37734 16.6053 3.52019 15.0017 3.17293 13.2558C2.82567 11.51 3.00391 9.70043 3.6851 8.0559C4.36629 6.41137 5.51984 5.00577 6.99988 4.01684C8.47992 3.02791 10.22 2.50008 12 2.50008C13.78 2.50008 15.5201 3.02791 17.0001 4.01684C18.4802 5.00577 19.6337 6.41137 20.3149 8.0559C20.9961 9.70043 21.1743 11.51 20.8271 13.2558C20.4798 15.0017 19.6227 16.6053 18.364 17.864L12 24.228ZM12 12.5C11.2044 12.5 10.4413 12.1839 9.87868 11.6213C9.31607 11.0587 9 10.2956 9 9.5C9 8.70435 9.31607 7.94129 9.87868 7.37868C10.4413 6.81607 11.2044 6.5 12 6.5C12.7957 6.5 13.5587 6.81607 14.1213 7.37868C14.6839 7.94129 15 8.70435 15 9.5C15 10.2956 14.6839 11.0587 14.1213 11.6213C13.5587 12.1839 12.7957 12.5 12 12.5Z"
                                      fill="#232323"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1921_2682">
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                        transform="translate(0 0.5)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                                Contact Rep
                              </a>
                            </div>
                            <div className="col-span-9 pt-4 mt-2 text-sm border-t border-gray-100">
                              {rep.markets?.length > 0 && (
                                <>
                                  <strong className="mr-3">
                                    Markets Served:{" "}
                                  </strong>
                                  {rep.markets.map((market, index) => (
                                    <span key={index} className="mr-3">
                                      {formatMarkets(market)}
                                    </span>
                                  ))}
                                </>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
